import { render, staticRenderFns } from "./big.vue?vue&type=template&id=74147cc7&scoped=true"
import script from "./big.vue?vue&type=script&lang=js"
export * from "./big.vue?vue&type=script&lang=js"
import style0 from "./big.vue?vue&type=style&index=0&id=74147cc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74147cc7",
  null
  
)

export default component.exports